/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'people': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M512 512a256 256 0 110-512 256 256 0 010 512zM0 1024c31.744-252.544 248.896-448 512-448 263.104 0 480.256 195.456 512 448H0z"/>'
  }
})
